/**
 * Handles external links by adding an icon indicator
 * 1. Checks for target="_blank"
 * 2. Skips links with class 'btn'
 * 3. Skips links inside specific parent containers
 * 4. Skips links that already contain a VISIBLE icon
 */
export class ExternalLinks {
  constructor() {
    this.init();
  }

  static isOnPage() {
    return document.querySelectorAll('a[href]').length > 0;
  }

  addExternalIcon(link) {
    if (link.querySelector('.external-link-icon')) { return; }

    const svgIcon = `
            <svg class="external-link-icon" aria-hidden="true" width="14" height="14"
               viewBox="0 0 20 20" fill="currentColor" style="margin-left: 4px; vertical-align: middle;">
              <path fill-rule="evenodd" clip-rule="evenodd"
                 d="M12.75 0.75C12.75 0.335786 13.0858 0 13.5 0H18.75C19.1642 0
                 19.5 0.335786 19.5 0.75V6C19.5 6.41421 19.1642 6.75 18.75 6.75C18.3358
                 6.75 18 6.41421 18 6V2.56066L5.78033 14.7803C5.48744 15.0732 5.01256
                 15.0732 4.71967 14.7803C4.42678 14.4874 4.42678 14.0126 4.71967
                 13.7197L16.9393 1.5H13.5C13.0858 1.5 12.75 1.16421 12.75 0.75ZM0.87868
                 3.87868C1.44129 3.31607 2.20435 3 3 3H11.25C11.6642 3 12 3.33579 12
                 3.75C12 4.16421 11.6642 4.5 11.25 4.5H3C2.60218 4.5 2.22064 4.65804
                 1.93934 4.93934C1.65804 5.22064 1.5 5.60218 1.5 6V16.5C1.5 16.8978
                 1.65804 17.2794 1.93934 17.5607C2.22064 17.842 2.60218 18 3 18H13.5C13.8978
                 18 14.2794 17.842 14.5607 17.5607C14.842 17.2794 15 16.8978 15 16.5V8.25C15
                 7.83579 15.3358 7.5 15.75 7.5C16.1642 7.5 16.5 7.83579 16.5 8.25V16.5C16.5
                 17.2957 16.1839 18.0587 15.6213 18.6213C15.0587 19.1839 14.2956 19.5
                 13.5 19.5H3C2.20435 19.5 1.44129 19.1839 0.87868 18.6213C0.316071 18.0587
                 0 17.2956 0 16.5V6C0 5.20435 0.316071 4.44129 0.87868 3.87868Z" />
            </svg>
        `;

    link.insertAdjacentHTML('beforeend', svgIcon);
  }

  processLinks() {
    const excludedParentClasses = [
        'intro-carousel',
        'header-top',
        'pushbox',
    ];

    const excludeSelector = excludedParentClasses.map(cls => '.' + cls).join(',');

    document.querySelectorAll('a[href]').forEach(link => {
      // 1. Skip if it has 'btn' class
      if (link.classList.contains('btn')) { return; }

      // 2. Skip if it DOES NOT have target="_blank"
      if (link.getAttribute('target') !== '_blank') { return; }

      // 3. Skip if link is inside any of the excluded parent containers
      if (excludeSelector && link.closest(excludeSelector)) { return; }

      // 4. Check for existing icons AND their visibility
      const existingIcon = link.querySelector('i, svg');
      if (existingIcon) {
        const style = window.getComputedStyle(existingIcon);
        if (style.display !== 'none') { return; }
      }

      this.addExternalIcon(link);
    });
  }

  init() {
    this.processLinks();
  }
}